import {Inject, Injectable, NgModule} from '@angular/core';
import { Socket } from 'ngx-socket-io';
import {ENVIRONMENT, IS_BROWSER} from "../utils/injectiontokens";

@Injectable({
  providedIn: 'root'
})
export class ExchangeSocket extends Socket {

  constructor(@Inject(ENVIRONMENT) protected environment: any,
              @Inject(IS_BROWSER) protected isBrowser: boolean) {

    let options = { transports: ['websocket'], autoConnect : false};
    if(isBrowser) {
      options['autoConnect'] = true;
    }
    let configuration = {url: environment.socketBasePath + '/exchanges', options: options};
    super(configuration);

  }

}
